import { useRouter } from 'next/router';
import { PageSortBy } from 'components/page';

interface Props {
  defaultSort: string;
  options: {
    text: string;
    value: string;
  }[];
}

const CoursesSortBy = ({ defaultSort, options }: Props) => {
  const router = useRouter();
  const sortBy = (router.query.sortBy as string) || defaultSort;

  const handleChange = async (value: string) => {
    router.replace({ query: { ...router.query, sortBy: value } }, undefined, {
      shallow: true
    });
  };

  return (
    <PageSortBy
      defaultValue={defaultSort}
      onChange={handleChange}
      options={options}
      titleMaxWidth={120}
      value={sortBy}
    />
  );
};

export default CoursesSortBy;
